<template>
  <v-app :style="loadingStyle">
    <v-dialog v-model="loading" :retain-focus="false" fullscreen hide-overlay>
      <loader_screen />
    </v-dialog>

    <v-fade-transition>
      <v-navigation-drawer
        v-if="!this.$store.getters.hasZenMode"
        :permanent="$vuetify.breakpoint.mdAndUp"
        app
        fixed
        height="100%"
        color="#e1e2e1"
        :expand-on-hover="true"
        v-model="sideNav"
        id="main_side-nav-bar"
        style="z-index: 2000 !important"
      >
        <v-app-bar
          color="#004c8c"
          dark
          text
          :collapse-on-scroll="true"
          style="height: 60px !important"
        >
          <v-app-bar-nav-icon @click="toogleSideNav"></v-app-bar-nav-icon>

          <v-toolbar-title class="hidden-xs-only" height="10">
            <router-link to="/" tag="span" style="cursor: pointer">
              SportEcoSys
            </router-link>
          </v-toolbar-title>
        </v-app-bar>
        <v-divider></v-divider>
        <!-- Side Navbar Links -->
        <v-list>
          <!-- Display grouped sections first -->
          <v-list-group
            v-for="(sectionRoutes, section) in groupedRoutes"
            :key="section"
            v-if="section !== '_noSection'"
            no-action
            color="blue"
          >
            <template v-slot:activator>
              <v-list-item-icon>
                <v-icon>{{ sectionIcons[section] || "sports_score" }}</v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{ section }}</v-list-item-title>
            </template>

            <v-list-item
              v-for="route in sectionRoutes"
              :key="route.name"
              @click="handleNavigation(route.path)"
            >
              <v-list-item-icon>
                <v-icon color="blue">{{ route.icon || "find_replace" }}</v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{
                route.name || "Untitled"
              }}</v-list-item-title>
            </v-list-item>
          </v-list-group>

          <!-- Display no-section routes at the end -->
          <template v-if="groupedRoutes._noSection">
            <v-list-item
              v-for="route in groupedRoutes._noSection"
              :key="route.name"
              @click="handleNavigation(route.path)"
            >
              <v-list-item-icon>
                <v-icon color="blue">{{ route.icon || "find_replace" }}</v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{
                route.name || "Untitled"
              }}</v-list-item-title>
            </v-list-item>
          </template>
        </v-list>
      </v-navigation-drawer>
    </v-fade-transition>

    <v-fade-transition>
      <!-- Horizontal Navbar -->
      <v-toolbar
        v-if="!this.$store.getters.hasZenMode"
        fixed
        color="light-blue darken-3"
        dark
        style="height: 60px; overflow: hidden"
        id="main_nav-bar"
      >
        <!-- App Title -->
        <v-app-bar-nav-icon @click="toogleSideNav"></v-app-bar-nav-icon>
        <v-toolbar-title>
          <router-link to="/" tag="span" style="cursor: pointer">
            <v-img
              max-width="90px"
              max-height="50px"
              :src="require('../public/og_logo.png')"
            />
          </router-link>
        </v-toolbar-title>

        <v-autocomplete
          v-if="this.user && this.getLeagues"
          v-bind:items="this.getAllowedLeagues() || []"
          append-icon="search"
          label="Select League/Federation"
          filled
          :hint="`${league}`"
          item-value="node.seqno"
          item-text="node.name"
          v-model="league"
          @input="updateLeagueSeqno(league)"
          dense
          color="secondary"
          outline
          class="autocomplete"
        >
          <template v-slot:item="data">
            <v-list-item-avatar class="autocomplete_img"></v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>
                {{ data.item.node.name }}
              </v-list-item-title>
            </v-list-item-content>
          </template>
          <template v-slot:selection="data">
            <v-chip>
              <v-avatar left>
                <v-img :src="require('../public/og_logo.png')"></v-img>
              </v-avatar>
              {{ data.item.node.name }}
            </v-chip>
          </template>
        </v-autocomplete>
        <v-spacer></v-spacer>

        <v-autocomplete
          v-if="this.user && this.clubs.length > 0"
          v-bind:items="this.getAllowedClubs() || []"
          append-icon="search"
          label="Select Club"
          filled
          :hint="`${club}`"
          item-value="node.clubId"
          item-text="node.clubName"
          v-model="club"
          @input="updateClubId(club)"
          dense
          color="secondary"
          outline
          class="autocomplete"
        >
          <template v-slot:item="data">
            <v-list-item-avatar class="autocomplete_img"></v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>
                {{ data.item.node.clubName }}
              </v-list-item-title>
              <v-list-item-subtitle
                v-html="
                  getIsDefaultClub(data.item.node.clubId) == 1
                    ? data.item.node.clubId + ' (Default)'
                    : data.item.node.clubId
                "
              ></v-list-item-subtitle>
            </v-list-item-content>
          </template>
          <template v-slot:selection="data">
            <v-chip>
              <v-avatar left>
                <v-img :src="require('../public/og_logo.png')"></v-img>
              </v-avatar>
              {{ data.item.node.clubName }}
            </v-chip>
          </template>
        </v-autocomplete>

        <v-spacer></v-spacer>

        <!-- Horizontal Navbar Links -->
        <v-toolbar-items>
          <v-btn
            text
            v-for="item in horizontalNavItems"
            :key="item.title"
            :to="item.link"
            exact
          >
            <v-icon left> {{ item.icon }}</v-icon>
            <span class="hidden-sm-and-down">
              {{ item.title }}
            </span>
          </v-btn>

          <v-btn text to="/auth/user_profile" v-if="user">
            <v-icon>account_box</v-icon>
            <v-badge class="hidden-sm-and-down" right color="green">
              <span slot="badge">1</span>
              Profile
            </v-badge>
          </v-btn>
          <v-btn text @click="handleSignoutUser" v-if="user">
            <v-icon>exit_to_app</v-icon>
            <span class="hidden-sm-and-down"> Signout </span>
          </v-btn>

          <v-btn text href="https://discord.gg/t895nJzAe9" target="_blank">
            <v-icon>help</v-icon>
            <span class="hidden-sm-and-down"> Help </span>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
    </v-fade-transition>
    <!-- App Content -->
    <main :style="mainBlockStyle">
      <v-container
        style="height: 100%; padding: 0 !important"
        class="mt-4"
        v-if="showContainer"
      >
        <transition name="fade">
          <router-view />
        </transition>
        <!-- Auth Stnakcbar -->
        <v-snackbar
          v-model="authSnackbar"
          class="hidden-xs-only"
          color="success"
          :timeout="1500"
          bottom
          right
        >
          <v-icon class="mr-3">check_cricle</v-icon>
          <h5>You are now signed in!</h5>
          <v-btn dark text @click="authSnackbar = false">Close</v-btn>
        </v-snackbar>
      </v-container>
      <div style="height: 100%; padding: 0 !important" v-else>
        <transition name="fade">
          <router-view />
        </transition>
      </div>
    </main>
    <ogFooter v-if="showFooter && !this.$store.getters.hasZenMode" />
  </v-app>
</template>

<script>
import ogFooter from "./components/shared/Footer.vue";
import { mapGetters } from "vuex";
import loader_screen from "./components/shared/loader_screen.vue";
import { routeWithoutFooter } from "./constants/global";
import BaseLoadingDialog from "@/components/base/BaseLoadingDialog.vue";

export default {
  name: "App",
  components: {
    ogFooter,
    loader_screen,
    BaseLoadingDialog,
  },
  data() {
    return {
      sideNav: false,
      timeNav: null,
      showDrawer: true,
      club: null,
      league: null,
      mini: true,
      allowedClubs: { userAccess: [] },
      //clubs: [],
      authSnackbar: false,
      showFooter: true,
      sectionIcons: {
        League: "sports_score",
        Club: "group",
        Library: "menu_book",
        Admin: "admin_panel_settings",
        Misc: "devices_other",
      },
    };
  },
  async created() {
    this.handleGetClubsList();
    this.handleGetLeaguesList();
    this.handleGetCategoryList();
    this.handleGetCatValuesList();
    this.validateIframe();
    //this.allowedClubs = this.getAllowedClubs();
  },

  watch: {
    // if we had no value for user before - show snackbar
    user(newValue, oldValue) {
      if (oldValue === null) {
        this.authSnackbar = true;
      }
      if (newValue) {
        this.applyDefaultClubValue();
      }
    },
    // eslint-disable-next-line no-unused-vars
    $route(to, from) {
      const hasRoute = routeWithoutFooter.filter((el) => el.name === to.name);
      this.showFooter = hasRoute.length <= 0;
    },
  },
  computed: {
    ...mapGetters(["loading", "clubs", "user", "clubInfo", "getLeagues"]),
    mainBlockStyle() {
      return this.$store.getters.hasZenMode
        ? { minHeight: "100vh" }
        : { minHeight: "93.5vh" };
    },
    // eslint-disable-next-line vue/return-in-computed-property
    groupedRoutes() {
      //const userClub = this.$store.getters.club;
      //const userLeague = this.$store.getters.league;

      const sections = this.$router.options.routes.reduce((acc, route) => {
        // Apply club and league access logic
        const hasClubAccess =
          !route.requiresClub || (route.requiresClub && this.club);
        const hasLeagueAccess =
          !route.requiresLeague || (route.requiresLeague && this.league);

        if (route.show !== 0 && hasClubAccess && hasLeagueAccess) {
          if (route.section) {
            if (!acc[route.section]) {
              acc[route.section] = [];
            }
            acc[route.section].push(route);
          } else {
            // Push routes without a section to a special _noSection array
            if (!acc._noSection) {
              acc._noSection = [];
            }
            acc._noSection.push(route);
          }
        }
        return acc;
      }, {});

      // Move _noSection routes to the end
      if (sections._noSection) {
        const noSectionRoutes = sections._noSection;
        delete sections._noSection;
        sections._noSection = noSectionRoutes; // Re-add it to the end
      }

      return sections;
    },
    loadingStyle() {
      if (this.loading) {
        return {
          width: "100vw",
          height: "100vh",
          overflow: "hidden",
        };
      } else {
        return {};
      }
    },

    showContainer() {
      switch (this.$route.name) {
        case "Signin":
          return false;
        case "Signup":
          return false;
        case "DrillLib":
          return false;
        case "Map":
          return false;
        default:
          return true;
      }
    },
    horizontalNavItems() {
      let items = [
        // { icon: "chat", title: "Posts", link: "/posts" },
        { icon: "lock_open", title: "Sign In", link: "/auth/signin" },
        { icon: "create", title: "Sign Up", link: "/auth/signup" },
      ];
      if (this.user) {
        items = [
          // { icon: "create", title: "TBD", link: "/signout" }
        ];
      }
      return items;
    },
  },
  mounted() {
    setTimeout(() => {
      if (this.$vuetify.breakpoint.smAndDown) {
        this.timeNav = 1;
      }

      if (
        this.user &&
        this.user.userAccess.edges
        //&& this.$router.history.current.name == "landing"
      ) {
        this.club = this.user.userAccess.edges
          .filter((club) => club.node.isDefault == 1)[0]
          .node.clubId.toString();
        this.updateClubId(this.club);

        if (this.$router.history.current.name == "landing") {
          this.sideNav = false;
        }
      } else if (this.$route.fullPath.includes("/club/")) {
        console.log(this.$route);
        this.club = this.$route.params.club;
        this.updateClubId(this.club);
      }
    }, 2000);
  },
  methods: {
    applyDefaultClubValue() {
      if (this.user && this.user.userAccess) {
        this.club = String(
          this.user.userAccess.edges.filter(
            (item) => item.node.isDefault === 1
          )[0].node.clubId
        );
      } else {
        this.club = "";
      }
    },
    getIsDefaultClub: function (clubId) {
      return this.user.userAccess.edges.filter(
        (club) => club.node.clubId == clubId
      ).length == 1
        ? this.user.userAccess.edges.filter(
            (club) => club.node.clubId == clubId
          )[0].node.isDefault
        : "";
    },
    getAllowedClubs: function () {
      if (this.clubs && this.user.userAccess.edges) {
        return this.clubs.filter((temp2_el) => {
          return (
            this.user.userAccess.edges
              .map((item) => item.node.clubId)
              .filter((temp1_el) => {
                return (
                  (this.user.role == "Administrator" ||
                    temp2_el.node.clubId == temp1_el) &&
                  (!this.league ||
                    (temp2_el.node.leagueClubRels.edges.length !== 0 &&
                      temp2_el.node.leagueClubRels.edges[0].node.leagueSeqno ==
                        this.league))
                );
              }).length > 0
          );
        });
      }
    },
    getAllowedLeagues: function () {
      //console.log(this.getLeagues);
      if (this.getLeagues) {
        return this.getLeagues;
      }
    },
    isUserAdmin: function () {
      if (this.user && this.user.role == "Administrator") {
        return 1;
      }
    },
    validateIframe() {
      if (window.self !== window.top) {
        this.$store.commit("toogleZenMode");
        //console.log("Vue.js app is rendered inside an iFrame");
      } else {
        //console.log("Vue.js app is not rendered inside an iFrame");
      }
    },
    toogleSideNav() {
      this.sideNav = !this.sideNav;
    },
    handleSignoutUser() {
      this.$store.dispatch("signoutUser");
    },
    handleGetClubsList() {
      //reach out of Vuex store, fire action that gets Clubs
      this.$store.dispatch("allClubs", {});
      //this.$store.dispatch("allClub", {});
    },
    handleGetLeaguesList() {
      //reach out of Vuex store, fire action that gets Clubs
      this.$store.dispatch("getAllLeagues", {});
    },
    handleGetCategoryList() {
      //reach out of Vuex store, fire action that gets athletes
      this.$store.dispatch("allCategory", {});
    },
    handleGetCatValuesList() {
      //reach out of Vuex store, fire action that gets athletes
      this.$store.dispatch("allCategoryValue", {});
    },

    updateClubId(clubId) {
      var curpath = this.$router.currentRoute;
      if (clubId) {
        console.log(clubId);
        this.$store.commit("setClub", clubId);
      }
      console.log(curpath);
      if (this.$route.fullPath.includes("/club/")) {
        this.$router.replace({
          path:
            "/" +
            clubId +
            curpath.path.substring(curpath.path.search("/club/")),
          query: curpath.query,

          params: { club: clubId },
        });
      }
    },
    updateLeagueSeqno(league) {
      if (league) {
        console.log(league);
        this.$store.commit("setLeague", league);
      }
      var curpath = this.$router.currentRoute;
      console.log(curpath);
      if (this.$route.fullPath.includes("/league/")) {
        this.$router.replace({
          path:
            "/" +
            league +
            curpath.path.substring(curpath.path.search("/league/")),
          query: curpath.query,
          params: { league: league },
        });
      }
    },
    handleNavigation(path) {
      const requiresClub = path.includes(":club");
      const requiresLeague = path.includes(":league");
      const missingParams = [];
      if (requiresClub && !this.$store.getters.club) {
        missingParams.push("club");
      }
      if (requiresLeague && !this.$store.getters.league) {
        missingParams.push("league");
      }

      if (missingParams.length) {
        alert(`Please select ${missingParams.join(" and ")}.`);
      } else {
        this.$router.push(this.generateFullPath(path));
      }
    },
    generateFullPath(path) {
      let fullPath = path;
      if (this.$store.getters.club) {
        fullPath = fullPath.replace(":club", this.$store.getters.club);
      }
      if (this.$store.getters.league) {
        fullPath = fullPath.replace(":league", this.$store.getters.league);
      }
      return fullPath;
    },
  },
};
</script>

<style>
#app {
  width: 100%;
  background-color: #eeeeee;
}

.autocomplete {
  height: 100% !important;
  margin-left: 30px !important;
}

.fade-enter-active,
.fade-leave-active {
  transition-property: opacity;
  transition-duration: 0.25s;
}

.fade-enter-active {
  transition-delay: 0.25s;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
  transform: translateY(-25px);
}

.overlay_loader {
  position: fixed;
  top: 0;
  left: 0;
  margin: 0 !important;
  padding: 0 !important;
}

.autocomplete_img {
  width: 50px;
  height: 50px;
  background-image: url("../public/og_logo.png");
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
}
</style>
